import { atom } from 'jotai'

/**
 * 車格マスタのインポートModalの表示状態
 */
export const isOpenTruckClassImportModalAtom = atom<boolean>(false)

isOpenTruckClassImportModalAtom.debugLabel = 'isOpenTruckClassImportModalAtom'
